/**
 * Created by tong on 2018/2/3.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Modal, Upload, Icon, InputNumber, Tree, Input, Tabs, Radio, Cascader} from 'antd';
import {treeList2, orgDetail} from '../../service/org';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, APIS, objectSerial, config, toImportExcel} from 'Utils';
import moment from 'moment';
import {
    getProductList,
    proBigNameScreening,
    proMiddleNameScreening,
    proDetailNameScreening,
    addFavoritesList,
    addShoppingCarList,
    batchRemove,
    uploadInformation,
    fetchSpecList,
    findId,
    initForList
} from '../../service/product';
import {categoryDetail} from '../../service/category';
import left from './right3.png';
import right from './left3.png';
import {Store, Actions} from './store';
import '../product/product.css';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;
const TabPane = Tabs.TabPane;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const customPrefix = '$radioVal_';
const getParentKey = (key, tree) => {
    let parentKey;
    for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
            if (node.children.some(item => item.key === key)) {
                parentKey = node.key;
            } else if (getParentKey(key, node.children)) {
                parentKey = getParentKey(key, node.children);
            }
        }
    }
    return parentKey;
}

class ProductList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['全部物料'],
            key: 0,
            button_limits_end: {},
            visible: false,
            proBigName_type: [],
            proMiddleName_type: [],
            proDetailName_type: [],
            selectedRowKeys: [],
            rows: [],
            total: 1,
            total2: 1,
            tree: [],
            keys: [],
            channelCode: this.channelData.split('|')[1] || '',
            searchObj: {
                name: '', /*物料名称 筛选*/
                channelCode: this.channelData.split('|')[1] || '',
                shellFrame: '', /*壳架 筛选*/
                proBigType: '', /*物料大类 筛选*/
                proMiddleType: '', /*物料中类 筛选*/
                proDetailType: '', /*物料中类 筛选*/
                proDetailName: '',
                stockType: '', /*库存类型 筛选*/
                createTimeStart: '', // 起
                createTimeEnd: '', // 止
                s: 10,
                p: 1
            },
            item: [],
            productId: '',
            count: '',
            informationProps: {
                name: 'file',
                action: APIS.upload,
                headers: {
                    authorization: 'authorization-text',
                },
                onChange: this.updateInformation.bind(this),
            },
            informationLi: [],
            inputNumber: '',  //加入购物车数量
            // loading: true,
            autoExpandParent: true,
            expandedKeys: [],
            searchValue: '',
            picLeft: left,
            picRight: right,
            left: left,
            right: right,
            L135: '135px',
            L130: '0px',
            L120: '0px',
            L950: '82%',
            L386: '380px',
            L1300: '93%',
            L1350: '300%',
            mainSpec: [],
            slaveSpec: [],
            bentiMsg: [],     //本体
            fujianMsg: [],    //附件
            add: {
                specifications: ''// 规格
            },
            sumC: {
                bentiMsg: [],
                fujianMsg: [],
                p: 1,
                s: 10
            },
            rowsFlag: 1,
            cascaderValue: [],
            xx: '选型'
        };
        this.addfFavorites = this.addfFavorites.bind(this);
        this.addShoppingCar = this.addShoppingCar.bind(this);
        this.importChange = this.importChange.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.exportChange = this.exportChange.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
        this.getData = this.getData.bind(this);
        this.onSelect = this.onSelect.bind(this);
        // this.onChange = this.onChange.bind(this);
    };


    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    getProBigName_type = () => {
        proBigNameScreening().then(res => { //物料大类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: '',
                        id: '',
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code,
                        id: x.id
                    })
                });
                this.setState({proBigName_type: arr},
                )
            }
        });
    };
    getProMiddleName_type = (id) => {
        proMiddleNameScreening(id).then(res => { //物料中类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: '',
                        id: '',
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.fullPath,
                        value: x.code,
                        id: x.id
                    })
                });
                this.setState({proMiddleName_type: arr})
            }
        });
    };
    getProDetailName_type = (id) => {
        proDetailNameScreening(id).then(res => { //明细类
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.fullPath,
                        value: x.code
                    })
                });
                this.setState({proDetailName_type: arr},)
            }
        })
    }

    componentWillMount() {
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                }
            });
        }
        this.getProBigName_type();
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /*选择列表*/
    onSelectChange = (selectedRowKeys, item) => {

        var selectitems = this.state.item;

        var items = [];

        item.forEach((key, i) => {

            var flag = true;

            selectitems.forEach((k, z) => {
                if (k.id == item[i].id) {
                    flag = false;
                    return;
                }
            })
            if (flag) {
                selectitems.push(item[i]);
            }
        });

        selectitems.forEach((key, i) => {
            if (selectedRowKeys.indexOf(key.id) >= 0) {
                items.push(selectitems[i]);
            }
        });

        this.setState({selectedRowKeys, item: items});
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'startDate') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    createTimeStart: value.from,
                    createTimeEnd: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}});
            if (name === 'proBigType') {
                const arr = this.state.proBigName_type.filter(item => item.value === value);
                let id = '';
                if (arr.length > 0) {
                    id = arr[0].id;
                }
                this.getProMiddleName_type(id);
            }
            if (name === 'proMiddleType') {
                const arr = this.state.proMiddleName_type.filter(item => item.value === value);
                let id = '';
                if (arr.length > 0) {
                    id = arr[0].id;
                }
                this.getProDetailName_type(id);
            }
        }
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '', /*物料名称 筛选*/
                shellFrame: '', /*壳架 筛选*/
                proBigType: '', /*物料大类 筛选*/
                proMiddleType: '', /*物料中类 筛选*/
                proDetailType: '', /*物料中类 筛选*/
                proDetailName: '', /*物料中类 筛选*/
                stockType: '', /*库存类型 筛选*/
                createTimeStart: '', // 起
                createTimeEnd: '', // 止
                s: 10,
                p: 1
            },
            cascaderValue: [],
            selectedRowKeys: []
        });
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, () => {
            self.initData();
        });
    };

    /*加入收藏夹*/
    addfFavorites(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要加入收藏夹的产品');
            return;
        }
        var _arr = [];
        item.forEach(ele => {
            _arr.push({productId: ele.id});
        });
        let self = this;
        addFavoritesList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '加入收藏夹成功', '');
                self.initData();
            } else {
                openNotice('error', '加入收藏夹失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*选择数量加减*/
    changeNumber = (record, index, value) => {
        var selectedRowKeys = [...this.state.selectedRowKeys];
        var item = [...this.state.item];
        var rows = [...this.state.rows];
        for (var i = 0; i < selectedRowKeys.length; i++) {
            if (selectedRowKeys[i] == record.id) {
                item[i].count = value;
            }
        }
        rows[index].count = value;
        this.setState({
            rows: rows
        });
    };

    /*加入购物车*/
    addShoppingCar(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择加入购物车的产品和数量');
            return;
        }
        var _arr = [];
        for (let i = 0, len = item.length; i < len; i++) {
            _arr.push({
                productId: item[i].id,
                channelCode: this.state.channelCode,
                count: (item[i].count < 1 || !item[i].count) ? 1 : item[i].count,
            })
            ;
            if (item[i].minPackageFlag === 'Y' && (item[i].count % item[i].minPackageQuantity)) {
                openNotice('warning', '购买数量必须是最小起订量的整数倍!');
                return;
            }
        }
        let self = this;
        addShoppingCarList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '加入购物车成功', '');
                self.initData();
            } else {
                openNotice('error', '加入购物车失败', (result && result.message) ? result.message : '');
            }
        });
    }

    /*批量上传资料*/
    importChange(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要批量上传资料的产品');
            return;
        }
        this.setState({visible: true});
    };

    /*上传附件*/
    updateInformation(result) {
        let informationLi = this.state.informationLi || [];
        informationLi = informationLi.slice(-1);    //控制上传数量
        if (result.file.status === 'done') {
            let responseData = result.file.response || {};
            if (responseData.code != 200) {
                openNotice('error', '附件上传失败');
                return;
            }
            informationLi.push({
                id: responseData.data.id,
                fileName: responseData.data.fileName,
            });
        }
        this.setState({
            informationLi: informationLi
        })
    };

    /* 批量上传资料提交 */
    handleOk = () => {
        const {informationLi, selectedRowKeys} = this.state;
        let params = {
            'ids': selectedRowKeys.join(','),
            'fileId': informationLi.map(x => {
                return x.id
            }).join(',')
        };
        uploadInformation(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '批量上传资料成功', '');
            } else {
                openNotice('error', '批量上传资料失败', (result && result.message) ? result.message : '');
            }
        });
        this.setState({visible: false});
    };
    handleCancel = () => {
        this.setState({visible: false});
    };

    /*批量清除资料*/
    removeChange(item) {
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择要批量清除资料的产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys

        };
        let self = this;
        batchRemove(params).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '批量清除资料成功', '');
                self.initData();
            } else {
                openNotice('error', '批量清除资料失败', (result && result.message) ? result.message : '');
            }
        });
    };

    /*导出*/
    exportChange() {
        let _rows = this.state.selectedRowKeys,
            _searchObj = {...this.state.searchObj};
        if (this.state.rows.length <= 0) {
            openNotice('warning', '请先查询再导出');
            return;
        }
        delete _searchObj.p;
        delete _searchObj.s;
        let url = `${config.server}/api/v1/dms/product/exportExcel?${objectSerial(_searchObj)}&proIds=${_rows.join('&proIds=')}`;
        window.open(url);
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        if (this.state.rowsFlag == 1) {
            this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
                self.initData();
            });
        }
        if (this.state.rowsFlag == 2) {
            this.setState({sumC: {...this.state.sumC, s: pageSize, p: page}},
                function () {
                    initForList(this.state.sumC).then(res => {
                        /* var tree = self.state.tree;
                         var proBigName = '';*/
                        res.data.forEach((item, i) => {
                            if (item.showPriceDate) {
                                res.data[i].showPriceDate = moment(res.data[i].showPriceDate).format("YYYY-MM-DD");
                            }
                            /*proBigName = '';
                            tree.map(itm => {
                                if (item.proBigType == itm.code) {
                                    console.log(itm);
                                    proBigName = itm.label + ".";
                                    itm['children'].map(itm2 => {
                                        if (item.proMiddleType == itm2.code) {
                                            proBigName = proBigName + itm2.label + ".";
                                            itm2['children'].map(itm3 => {
                                                if (item.proDetailType == itm3.code) {
                                                    proBigName = proBigName + itm3.label;
                                                }
                                            })
                                        }
                                    })
                                }
                            });
                            res.data[i].proBigName = proBigName;*/
                        });
                        if (res && res.code == 200) {
                            self.setState({
                                'rows': res.data,
                                'total2': res.total,
                                'loading': false,
                            });
                        } else {
                            openNotice('error', '数据获取失败', '');
                            self.setState({'loading': false});
                        }
                    })
                }
            )
        }
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        if (!searchObj.name && !searchObj.proDetailType) {
            openNotice('warning', '请先填写“产品分类”或“物料名称”进行查询');
            return
        }
        self.setState({
            loading: true,
            selectedRowKeys: []
        })

        console.log(searchObj);
        getProductList(searchObj).then(function (result) {
            if (result && result.code == 200) {
                /*var tree = self.state.tree;
                var proBigName = '';*/
                result.data.forEach((item, i) => {
                    if (item.showPriceDate) {
                        result.data[i].showPriceDate = moment(result.data[i].showPriceDate).format("YYYY-MM-DD");
                    }
                    /*proBigName = '';
                    tree.map(itm => {
                        if (item.proBigType == itm.code) {
                            console.log(itm);
                            proBigName = itm.label + ".";
                            itm['children'].map(itm2 => {
                                if (item.proMiddleType == itm2.code) {
                                    proBigName = proBigName + itm2.label + ".";
                                    itm2['children'].map(itm3 => {
                                        if (item.proDetailType == itm3.code) {
                                            proBigName = proBigName + itm3.label;
                                        }
                                    })
                                }
                            })
                        }
                    });
                    result.data[i].proBigName = proBigName;*/
                });
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false,
                    'rowsFlag': 1,
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({'loading': false});
            }
        });
    }

    componentDidMount() {
        //this.getData();
        // this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }


    getData() {
        treeList2('').then(result => {
            if (result.status) {
                /*for (var i = 0; i < result.data.length; i++) {
                    result.data[i].value = result.data[i].code
                    for (var j = 0; j < result.data[i]['children'].length; j++) {
                        result.data[i]['children'][j].value = result.data[i]['children'][j].code
                        for (var z = 0; z < result.data[i]['children'][j]['children'].length; z++) {
                            result.data[i]['children'][j]['children'][z].value = result.data[i]['children'][j]['children'][z].code;
                            delete result.data[i]['children'][j]['children'][z].children;
                        }
                    }
                }*/

                const filterEmpty = (list) => list.map(x => {
                    if (x.children && x.children.length) {
                        return {
                            ...x,
                            value: x.code,
                            children: filterEmpty(x.children),
                        };
                    }
                    return {
                        ...x,
                        value: x.code,
                        children: undefined,
                    };
                });
                this.setState({
                    // tree: result.data
                    tree: filterEmpty(result.data || [])
                })
            } else {
                openNotice('warning', result.message);
            }
        })
    }

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onSelect(selectedKeys, e) {
        // console.log(selectedKeys);
        // console.log(e);
        const self = this;
        if (selectedKeys.length != 0) {
            this.setState({
                keys: selectedKeys,
            });
            var searchObj = {...this.state.searchObj};
            if (e.node.props.value == 1) {
                searchObj.proBigType = e.node.props.code;
            }
            if (e.node.props.value == 2) {
                searchObj.proMiddleType = e.node.props.code;
            }
            if (e.node.props.value == 3) {
                searchObj.proDetailType = e.node.props.code;
                searchObj.proDetailName = e.node.props.code;
                var x = e.node.props.code;
                // findId(x).then( res => {
                // 	console.log(res);
                // })
            }
            self.setState({
                loading: true
            })
            getProductList(searchObj).then(function (result) {
                if (result && result.code == 200) {
                    /*var tree = self.state.tree;
                    var proBigName = '';*/
                    result.data.forEach((item, i) => {
                        if (item.showPriceDate) {
                            result.data[i].showPriceDate = moment(result.data[i].showPriceDate).format("YYYY-MM-DD");
                        }
                        /*proBigName = '';
                        tree.map(itm => {
                            if (item.proBigType == itm.code) {
                                console.log(itm);
                                proBigName = itm.label + ".";
                                itm['children'].map(itm2 => {
                                    if (item.proMiddleType == itm2.code) {
                                        proBigName = proBigName + itm2.label + ".";
                                        itm2['children'].map(itm3 => {
                                            if (item.proDetailType == itm3.code) {
                                                proBigName = proBigName + itm3.label;
                                            }
                                        })
                                    }
                                })
                            }
                        });
                        result.data[i].proBigName = proBigName;*/
                    });
                    self.setState({
                        'rows': result.data || [],
                        'total': result.total,
                        'loading': false,
                        'rowsFlag': 1,
                    });
                    /*本体附件*/
                    if (e.node.props.value == 3) {
                        self.getSpecList(x);
                    }
                } else {
                    openNotice('warning', '数据获取失败', '');
                    self.setState({'loading': false});
                }
            });
        }
    }

    onChange = (e) => {
        const self = this;
        const value = e.target.value.toUpperCase();
        const list = [];
        if (value == '') {
            return
        }
        // console.log(e.target.value);
        getParentKey(self.state.tree);
        self.setState({
            expandedKeys: list,
            searchValue: value,
            autoExpandParent: true,
        })

        function getParentKey(arr) {
            for (let i = 0; i < arr.length; i++) {
                const node = arr[i];
                if (node.label.indexOf(value) > -1) {
                    list.push(node.key);
                }
                if (node.children) {
                    getParentKey(node.children);
                }
            }
        }
    }

    keyPress = (e) => {
        // console.log(e)
        const self = this;
        const list = [];
        const value = e.target.value.toUpperCase();
        //TODO
        var code = e.charCode || e.keyCode;  //取出按键信息中的按键代码(大部分浏览器通过keyCode属性获取按键代码，但少部分浏览器使用的却是charCode)
        if (code == 13) {
            //此处编写用户敲回车后的代码
            //回车执行查询
            getParentKey(self.state.tree);
            self.setState({
                expandedKeys: list,
                searchValue: value,
                autoExpandParent: true,
            })
        }

        /*
        const expandedKeys = self.state.tree.map((item) => {
            if (item.key.indexOf(value) > -1) {
                return getParentKey(item.key, self.state.tree);
            }
            return null;
        }).filter((item, i, self) => item && self.indexOf(item) === i);
        self.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });*/

        function getParentKey(arr) {
            for (let i = 0; i < arr.length; i++) {
                const node = arr[i];
                if (node.label.indexOf(value) > -1) {
                    list.push(node.key);
                }
                if (node.children) {
                    getParentKey(node.children);
                }
            }
        }
    }

    // 改变位置
    changePosition = () => {
        if (this.state.picLeft == this.state.right) {
            this.setState({
                picLeft: this.state.left,
                L135: '0',
                L130: '-160px',
                L950: '82%',
                L386: '244px',
                L120: '-135px'
            })
        }
        if (this.state.picLeft == this.state.left) {
            this.setState({
                picLeft: this.state.right,
                L135: '135px',
                L130: '0',
                L950: '82%',
                L386: '380px',
                L120: '0px'
            })
        }
    }
    changePosition2 = () => {
        if (this.state.picRight == this.state.right) {
            this.setState({picRight: this.state.left, L1300: '93%', L1350: '17%', xx: '关闭'})
        }
        if (this.state.picRight == this.state.left) {
            this.setState({picRight: this.state.right, L1300: '93%', L1350: '300%', xx: '选型'})
        }
    }
    /*本体附件接口*/
    getSpecList = (categoryId) => {
        findId(categoryId).then(result => {
            if (result.status && result.code == 200) {
                var arr1 = [], // 本体
                    arr2 = []; // 附件

                result.data.bentiMsg.forEach(ele => {
                    arr1.push(ele);
                });
                result.data.fujianMsg.forEach(ele => {
                    arr2.push(ele);
                });
                this.setState({
                    mainSpec: arr1,
                    slaveSpec: arr2
                });
            } else {
                openNotice('warning', '获取规格失败', result.message || '');
            }
        });
    }

    CascaderClick() {
        if (this.state.tree == null || this.state.tree == '') {
            this.getData();
        }
    }


    CascaderFilter = (inputValue, path) => {
        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
    }

    CascaderChange = (value, selectedOptions) => {
        this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    proBigType: selectedOptions[0].value,
                    proMiddleType: selectedOptions[1].value,
                    proDetailType: selectedOptions[2].value,
                    proDetailName: selectedOptions[2].label
                },
                cascaderValue: value
            },
            this.getSpecList(selectedOptions[2].value)
        );
    }

    /*本体附件选中显示*/
    radioOnChange = (e) => {
        let self = this;
        // console.log('radio checked', e.target.value);
        // console.log(this.state.bentiMsg);
        // console.log(this.state.fujianMsg);
        // console.log(e);
        this.setState({[customPrefix + e.target.propertyNum]: e.target.value}, () => {
            var arr = [];
            // console.log(this.state.mainSpec);
            for (var name in this.state) {
                if (name.indexOf(customPrefix) > -1) {
                    arr.push(this.state[name]);
                }
            }
            // console.log(arr);

            self.setState({add: {...this.state.add, specifications: arr.toString()}});
        });
    }
    radioBtnChange = (index, val, type, ele, i, e) => {
        //   	console.log(index);
        //   	console.log(val);
        //   	console.log(type);
        //   	console.log(e);
        // console.dir(e.target.name);
        const self = this;
        let prefix = type == 1 ? 'anotherPrefixSlave' : 'anotherPrefixMain';
        if (e.target.parentElement.parentElement.className.lastIndexOf('checked') > -1) {
            // console.log('same');
            this.setState({[prefix + index]: {name: ele.propertyName, val: ''}}, () => {
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                // console.dir(arr)
                var _str = arr.toString();
                self.setState({add: {...this.state.add, specifications: _str, specUnionKey: _str, proContent: _str}});
            });
        } else {
            this.setState({[prefix + index]: {name: ele.propertyName, val: val}}, () => {
                // let _obj = self.state['anotherPrefix' + index];
                // console.log(_obj.name + ': \n\r' + _obj.val)
                var arr = [];
                for (var ele in self.state) {
                    if (ele.indexOf('anotherPrefix') > -1 && self.state[ele].val) {
                        arr.push(self.state[ele].name + ': ' + self.state[ele].val);
                    }
                }
                // console.dir(arr)
                var _str = arr.toString();
                self.setState({add: {...this.state.add, specifications: _str, specUnionKey: _str, proContent: _str}});
            })
        }

        var sumC = {...this.state.sumC};
        var sumD = {...this.state.sumC};
        var x = sumD.bentiMsg.length;
        var y = sumD.fujianMsg.length;
        if (type == 0) {
            var sumA = {
                categoryId: ele.categoryId || '',
                propertyNum: ele.propertyNum || '',
                propertyCategoryCode: ele.propertyCategoryCode || '',
                propertyDesc: val || '',
                name: ele.propertyName || ''
            }
            sumC.bentiMsg.push(sumA);
            for (var i = 0; i < x; i++) {
                var sumBEN = sumC.bentiMsg[i];
                if (sumC.bentiMsg[i].name == ele.propertyName) {
                    sumC.bentiMsg.splice(i, 1, sumA);
                    if (sumBEN.propertyDesc == val) {
                        sumC.bentiMsg.splice(i, 1, 'undefined');
                        sumC.bentiMsg.pop();
                        sumC.bentiMsg.push('undefined');
                    }
                }
            }
        }
        if (type == 1) {
            var sumA = {
                categoryId: ele.categoryId || '',
                propertyNum: ele.propertyNum || '',
                propertyCategoryCode: ele.propertyCategoryCode || '',
                propertyDesc: val || '',
                name: ele.propertyName || ''
            }
            sumC.fujianMsg.push(sumA);
            for (var i = 0; i < y; i++) {
                var sumBEN = sumC.fujianMsg[i];
                if (sumC.fujianMsg[i].name == ele.propertyName) {
                    sumC.fujianMsg.splice(i, 1, sumA);
                    if (sumBEN.propertyDesc == val) {
                        sumC.fujianMsg.splice(i, 1, 'undefined');
                        sumC.fujianMsg.pop();
                        sumC.fujianMsg.push('undefined');
                    }
                }
            }
        }
        var hash = {};
        sumC.bentiMsg = sumC.bentiMsg.reduce(function (item, next) {
            hash[next.name] ? '' : hash[next.name] = true && item.push(next);
            return item
        }, [])
        sumC.fujianMsg = sumC.fujianMsg.reduce(function (item, next) {
            hash[next.name] ? '' : hash[next.name] = true && item.push(next);
            return item
        }, [])

        function clear_arr_trim(array) {
            for (var i = 0; i < array.length; i++) {
                if (array[i] == 'undefined' || array[i] == '' || typeof(array[i]) == 'undefined') {
                    array.splice(i, 1);
                    i = i - 1;
                }
            }
            return array;
        };
        clear_arr_trim(sumC.bentiMsg);
        clear_arr_trim(sumC.fujianMsg);
        sumC.channelCode = this.state.channelCode;
        // console.log(sumC);
        initForList(sumC).then(res => {
            // console.log(res);
            if (res && res.code == 200) {
                /*var tree = self.state.tree;
                var proBigName = '';*/
                res.data.forEach((item, i) => {
                    if (item.showPriceDate) {
                        res.data[i].showPriceDate = moment(res.data[i].showPriceDate).format("YYYY-MM-DD");
                    }
                    /*proBigName = '';
                    tree.map(itm => {
                        if (item.proBigType == itm.code) {
                            console.log(itm);
                            proBigName = itm.label + ".";
                            itm['children'].map(itm2 => {
                                if (item.proMiddleType == itm2.code) {
                                    proBigName = proBigName + itm2.label + ".";
                                    itm2['children'].map(itm3 => {
                                        if (item.proDetailType == itm3.code) {
                                            proBigName = proBigName + itm3.label;
                                        }
                                    })
                                }
                            })
                        }
                    });
                    res.data[i].proBigName = proBigName;*/
                })
                self.setState({
                    'rows': res.data,
                    'total2': res.total,
                    'loading': false,
                    'rowsFlag': 2,
                });
            } else {
                openNotice('warning', '数据获取失败', '');
                self.setState({'loading': false});
            }
        })
        this.setState({sumC: sumC});
    }

    /*下载模板*/
    downloadChange = () => {
        window.open(`${config.server}/file/product.xlsx`)
    }

    render() {
        const {
            opts, key, rows, total, total2, rowsFlag, sumC, searchObj, selectedRowKeys, proBigName_type, proMiddleName_type, button_limits_end, proDetailName_type, informationProps, loading, keys, autoExpandParent, expandedKeys, searchValue, tree, cascaderValue
        }
            = this.state;

        let uploadParam = toImportExcel(9, () => {
            this.getData();
        });
        // const loop = data => data.map((item,key) => {
        //   if (item.children && item.children.length) {
        // 	return <TreeNode key={item.key} title={item.label} value={item.level} code={item.code}>{loop(item.children)}</TreeNode>;
        //   }
        //   return <TreeNode key={item.key} title={item.label}  value={item.level} code={item.code}/>;
        // });
        const loop = data => data.map((item, key) => {
            const index = item.key.indexOf(searchValue);
            const beforeStr = item.key.substr(0, index);
            const afterStr = item.key.substr(index + searchValue.length);
            const title = index > -1 ? (
                <span>
			  {beforeStr}
                    <span style={{color: '#f50'}}>{searchValue}</span>
                    {afterStr}
			</span>
            ) : <span>{item.key}</span>;
            if (item.children && item.children.length) {
                return <TreeNode key={item.key} title={item.label} value={item.level}
                                 code={item.code}>{loop(item.children)}</TreeNode>;
            }
            return <TreeNode key={item.key} title={item.label} value={item.level} code={item.code}/>;
        });
        //选型
        const radioLayout = {marginLeft: 10},
            radioButtonLayout = {marginRight: 10};

        var mainRenderer = (this.state.mainSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                return <RadioButton style={radioButtonLayout} key={i} id={ele.id} name={ele.propertyName} value={e}
                                    onClick={this.radioBtnChange.bind(this, index, e, 0, ele, i)}>{e}</RadioButton>
            });
            if (index > 0) {
                return (
                    <div key={index}
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixMain' + index] && this.state['anotherPrefixMain' + index].val}
                            style={radioLayout} onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
            else {
                return (
                    <div key={index}
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixMain' + index] && this.state['anotherPrefixMain' + index].val}
                            style={radioLayout} onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });

        var slaveRenderer = (this.state.slaveSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                return <RadioButton style={radioButtonLayout} key={i} id={ele.id} name={ele.propertyName} value={e}
                                    onClick={this.radioBtnChange.bind(this, index, e, 1, ele, i)}>{e}</RadioButton>
            });
            if (index > 0) {
                return (
                    <div key={index}
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixSlave' + index] && this.state['anotherPrefixSlave' + index].val}
                            style={radioLayout} onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            } else {
                return (
                    <div key={index}
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/> {ele.propertyName}</div>
                        <RadioGroup
                            value={this.state['anotherPrefixSlave' + index] && this.state['anotherPrefixSlave' + index].val}
                            style={radioLayout} onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });
        const advanceProps = {
            fileds: [
                {
                    name: 'name',
                    label: '物料名称/编号',
                    text: '输入物料名称/编号',
                    type: 'default',
                    defaultValue: searchObj.name
                },
                {
                    name: 'shellFrame',
                    label: '壳架',
                    text: '输入壳架',
                    type: 'default',
                    defaultValue: searchObj.shellFrame
                },

                /*{
                    name: 'proBigType',
                    label: '物料大类',
                    text: '选择物料大类',
                    options: proBigName_type,
                    multiple: false,//支持多选
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.proBigType,
                },
                {
                    name: 'proMiddleType',
                    label: '物料中类',
                    text: '选择物料中类',
                    options: proMiddleName_type,
                    multiple: false,//支持多选
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.proMiddleType,
                },
                {
                    name: 'proDetailType',
                    label: '物料明细类',
                    text: '选择明细类',
                    options: proDetailName_type,
                    multiple: false,//支持多选
                    showSearch: true,
                    type: 'select',
                    defaultValue: searchObj.proDetailType,
                },*/

                {
                    name: 'stockType',
                    label: '库存类型',
                    text: '选择状态',
                    options: [
                        {value: '', text: '全部'},
                        {value: '库存', text: '库存'},
                        {value: '非库存', text: '非库存'},
                        {value: '定制', text: '定制'},
                        {value: '退市', text: '退市'},
                        {value: '专属定制', text: '专属定制'}
                    ],
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: searchObj.stockType
                },
                {
                    name: 'startDate',
                    label: '价格起始日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.createTimeStart || '',
                        end: searchObj.createTimeEnd || ''
                    },
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: rowsFlag == 1 ? total : total2,
                current: rowsFlag == 1 ? searchObj.p : sumC.p,//当前页码
                pageSize: rowsFlag == 1 ? searchObj.s : sumC.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料名称',
                    dataIndex: 'name',
                    width: 200,
                    render: (text, record, index) => {
                        /*if (record.orderManagerFlag == '' || record.orderManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else if (record.itemManagerFlag == '' || record.itemManagerFlag == null) {
                            return (<span>{text}</span>)
                        } else {*/
                        return (<a href={`#/product/${record.id}`} style={{whiteSpace: 'pre-wrap'}}>{text}</a>)
                        /*}*/
                    }
                },
                {
                    title: '物料类别编码',
                    dataIndex: 'proBigCode',
                    render: (text, record, index) => {
                        return record.proBigType + "." + record.proMiddleType + "." + record.proDetailType
                    }
                },
                {
                    title: '物料类别',
                    dataIndex: 'proBigName',
                    render: (text, record, index) => {
                        return record.proBigName + "." + record.proMiddleName + "." + record.proDetailName
                    }
                },
                {
                    title: '生产车间',
                    dataIndex: 'factoryName',
                    width: 120
                },
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                    width: 120
                }, {
                    title: '单位',
                    dataIndex: 'unit'
                },
                {
                    title: '库存类型',
                    dataIndex: 'stockType'
                },
                {
                    title: '最小装箱数',
                    dataIndex: 'minOrderQuantity'
                },
                {
                    title: '最小起订量',
                    dataIndex: 'minPackageQuantity'
                },
                {
                    title: '装箱数',
                    dataIndex: 'packageQuantity'
                },
                {
                    title: '产品线',
                    dataIndex: 'proLine',
                    render: (text, record, index) => {
                        if (text === '01') return '元器件';
                        if (text === '02') return '电工';
                        if (text === '03') return '电表';
                        if (text === '04') return '变频器';
                        if (text === '05') return '天e';
                        if (text === '06') return 'TG精品';
                        return '';
                    }
                },
                {
                    title: '壳架',
                    dataIndex: 'shellFrame'
                },
                {
                    title: '牌价',
                    dataIndex: 'showPrice',
                    render: text => <span style={{color: '#d61518'}}>{text}</span>
                },
                // {
                //     title: '牌价起始日期',
                //     dataIndex: 'showPriceDate'
                // },
                // {
                //     title: '原牌价',
                //     dataIndex: 'lastPrice',
                //     render: text => <span style={{color: '#d61518'}}>{text}</span>
                // },
                // {
                //     title: '涨幅',
                //     dataIndex: 'showPrice1',
                //     render: (text, record, index) => {
                //         if (record.lastPrice != null) {
                //             if (record.showPrice > record.lastPrice) {
                //                 return <span>{((record.showPrice - record.lastPrice) / record.lastPrice * 100).toFixed(2)}%<Icon
                //                     type="arrow-up"/></span>
                //             } else if (record.showPrice < record.lastPrice) {
                //                 return <span>{((record.showPrice - record.lastPrice) / record.lastPrice * 100).toFixed(2)}%<Icon
                //                     type="arrow-down"/></span>
                //             } else {
                //                 return <span><Icon type="minus"/></span>
                //             }
                //         } else {
                //             return <span><Icon type="minus"/></span>
                //         }
                //     }
                // },
                {
                    title: '购买数量',
                    dataIndex: 'count',
                    render: (text, record, index) => {
                        return <InputNumber
                            min={record.minPackageFlag === 'Y' && record.minPackageQuantity ? record.minPackageQuantity : 0}
                            defaultValue={~~record.count || 1}
                            step={record.minPackageFlag === 'Y' && record.minPackageQuantity ? record.minPackageQuantity : 1}
                            onChange={this.changeNumber.bind(this, record, index)}
                        />
                    }
                },
            ],
            rows,
            rowSelection: {
                selectedRowKeys,
                onChange: this.onSelectChange,
                /*getCheckboxProps: record => ({
                    disabled: (record.itemManagerFlag == null || record.orderManagerFlag == null)
                })*/
            }
        };
        const iconLayout = {
            fontSize: '32px',
            cursor: 'pointer'
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div style={{display: 'flex', background: '#fff', marginBottom: '200px'}}>
                {/*<div style={{marginLeft:this.state.L120,background:'#fff',flex:15,padding:'20px'}}>
              <div style={{ width:'100%',position:'relative'}}>
				<Button
					style={{position:'fixed',left:this.state.L386,top:345,width:'30px',height:'30px',zIndex:'10',padding:'0',border:'1px solid #ccc',margin:'0',borderRadius:'5px'}}
					onClick={this.changePosition.bind(this)}
				>
					<img src={this.state.picLeft} style={{width:'28px',height:'28px',borderRadius:'5px'}}/>
				</Button>
				<div style={{marginLeft:this.state.L130 }}>
					<Search style={{ marginBottom: 8 ,width:'130px'}} placeholder="搜索"
					// onChange={this.onChange.bind(this)}
					onKeyPress={this.keyPress.bind(this)}
					onClick={this.onChange.bind(this)}/>
					<div style={{height:'600px',overflowY:'auto'}}>
						<Tree
							 showLine
							 // defaultExpandAll
							 onSelect={this.onSelect}
							 selectedKeys={keys}
							 onExpand={this.onExpand.bind(this)}
							 expandedKeys={expandedKeys}
							 autoExpandParent={autoExpandParent}
							 style={{ marginTop:30,width:'100%',height:'100%'}}
						>
							 {loop(this.state.tree)}
						 </Tree>
					</div>
				 </div>
			</div>

			<Button style={{position:'fixed',
							left:'28%',
							top:'10%',
							width:'70px',
							height:'30px',
							zIndex:'1001',
							padding:'0',
							border:'1px solid #ccc',
							margin:'0',
							lineHeight:'30px',
							borderRadius:'5px',
						}}
					onClick={this.changePosition2.bind(this)}
			>
				<img src={this.state.picRight}
					 style={{width:'28px',height:'28px',borderRadius:'5px',float:'left'}}/>
				<div style={{width:'20px',height:'28px',float:'left'}}>选型</div>
			</Button>
			<div style={{width:'77%',height:'80%',border:'1px solid #ccc',left:this.state.L1350,position:'fixed',top:'10%',background:'#fff',overflowY:'auto',zIndex:'1000'}}>
				<section className="code-box-meta markdown">
					<div className="code-box-title">选型</div>
					<Tabs type="card">
						<TabPane tab="本体" key="1">
							{mainRenderer}
						</TabPane>
						<TabPane tab="附件" key="2">
							{slaveRenderer}
						</TabPane>
					</Tabs>
				</section>
			</div>
		</div>
		*/}
                <div style={{flex: 85}}>
                    <div className="advanceForm-box">
                        <div className="advanceForm-content">
                            <div style={{paddingLeft: '40px', marginBottom: '10px'}}>
                                <label>产品分类：</label>
                                <Cascader style={{width: '550px'}} options={tree}
                                          value={cascaderValue}
                                          onChange={this.CascaderChange.bind(this)}
                                          onClick={this.CascaderClick.bind(this)}
                                          placeholder="请选择产品分类"
                                          showSearch={{filter: this.CascaderFilter}}
                                />
                                <span
                                    style={{
                                        position: 'fixed',
                                        zIndex: '1001',
                                        padding: '0',
                                        margin: '0',
                                        marginLeft: '10px',
                                    }}
                                >
                                    <Button
                                        icon="filter"
                                        onClick={this.changePosition2.bind(this)}
                                    >
                                        {this.state.xx}
                                    </Button>
                                </span>
                                <div style={{
                                    width: '77%',
                                    height: '80%',
                                    border: '1px solid #ccc',
                                    left: this.state.L1350,
                                    position: 'fixed',
                                    top: '10%',
                                    background: '#fff',
                                    overflowY: 'auto',
                                    zIndex: '1000'
                                }}>
                                    <section className="code-box-meta markdown">
                                        <div className="code-box-title">选型</div>
                                        <Tabs type="card">
                                            <TabPane tab="本体" key="1">
                                                {mainRenderer}
                                            </TabPane>
                                            <TabPane tab="附件" key="2">
                                                {slaveRenderer}
                                            </TabPane>
                                        </Tabs>
                                    </section>
                                </div>
                            </div>
                            <AdvanceFormNew {...advanceProps} />
                        </div>
                    </div>
                    <div className="dms-table-box">
                        <div className="dms-table-head">
                            {/*{ button_limits_end.product_list_01 &&
			  <i onClick={this.addfFavorites.bind(this, this.state.item)} className="anticon anticon-star-o"
				 style={iconLayout}></i>}&nbsp;&nbsp;*/}
                            <div style={{textAlign: 'left', paddingBottom: '5px'}}>
                                {button_limits_end.product_list_02 &&
                                <Button size="large" type="primary"
                                        onClick={this.addShoppingCar.bind(this, this.state.item)}>加入购物车</Button>}</div>
                            <div style={{textAlign: 'right', paddingBottom: '5px'}}>
                                {/*<Upload {...uploadParam} style={{float: 'right!important'}}>*/}
                                {/*<Button style={{bottom: '3px', zIndex: '999'}}>*/}
                                {/*<Icon type="upload" />导入*/}
                                {/*</Button>*/}
                                {/*</Upload>*/}
                                {/*<Button icon="download" style={{bottom: '3px', zIndex: '999'}} onClick={this.downloadChange}>下载模板</Button>*/}
                                {button_limits_end.product_list_03 &&
                                <Button style={{bottom: '3px', zIndex: '999'}}
                                        onClick={this.importChange}>批量上传资料</Button>}
                                {button_limits_end.product_list_04 &&
                                <Button onClick={this.removeChange.bind(this, this.state.item)}
                                        style={{bottom: '3px', zIndex: '999'}}>批量清除资料</Button>}
                                {button_limits_end.product_list_05
                                &&
                                <Button style={{bottom: '3px', zIndex: '999'}} icon="export"
                                        onClick={this.exportChange}>导出</Button>}
                            </div>
                            <TableView {...tableViewProps}
                                // style={{width:this.state.L950,marginLeft:'0px'}}
                            />
                            {/*button_limits_end.product_list_05 && <Button  style={{position:'absolute', bottom:8, right:0}} icon="export" onClick={this.exportChange}>导出</Button>*/}
                        </div>

                    </div>
                </div>
            </div>


            <Modal
                visible={this.state.visible}
                title="批量上传资料"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
                width={"50%"}
                style={{top: "30%"}}
            >
                <div>
                    <div style={{padding: '12px', background: '#fff'}}>
                        <label>附件：</label>
                        <Upload {...informationProps} >
                            <Button>
                                <Icon type="upload"/> 上传附件
                            </Button>
                        </Upload>
                    </div>
                </div>
            </Modal>
        </div>
    }
}
;
export default withRouter(ProductList);



// WEBPACK FOOTER //
// ./src/routes/product/list.js